import Axios from "axios";
import { Store } from "redux";
const axios = Axios.create();

export namespace ActionType {
    export const REQUEST_STARTED = "REQUEST_STARTED";
    export interface REQUEST_STARTED_PAYLOAD {
        url: string,
        data: any
    }
    export const REQUEST_FAILED = "REQUEST_FAILED";
    export interface REQUEST_FAILED_PAYLOAD {
        error: any
    }
    export const REQUEST_FINISHED = "REQUEST_FINISHED";
    export interface REQUEST_FINISHED_PAYLOAD {
        url: string,
        data: any,
        response: any
    }
}

export function applyToStore(store: Store<any>) {
    axios.interceptors.request.use((config) => {
        store.dispatch({
            type: ActionType.REQUEST_STARTED,
            payload: {
                url: config.url,
                data: config.data
            } as ActionType.REQUEST_STARTED_PAYLOAD
        })
        return config;
    })
    axios.interceptors.response.use((config) => {        
        store.dispatch({
            type: ActionType.REQUEST_FINISHED,
            payload: {
                url: config.config.url,
                data: config.config.data,
                response: config.data
            } as ActionType.REQUEST_FINISHED_PAYLOAD
        })
        return config
    }, (error) => {
        store.dispatch({
            type: ActionType.REQUEST_FAILED,
            payload: {
               error
            } as ActionType.REQUEST_FAILED_PAYLOAD
        })
    })
}
export const api = {
    get: function <T>(url: string, data?: any) {
        //TODO: handle data from ResultModel
        return axios.get(url, { params: data }).then((response) => response.data as T)
    },
    put: (url: string, data?: any) => {
        //TODO:handle data from ResultModel
        return axios.put(url, data)
    },
    post: function <T>(url: string, data?: any) {
        //TODO:handle data from ResultModel
        return axios.post(url, data).then((response) => response.data as T).catch(error => console.log(error))
    },
    delete: (url: string, data?: any) => {
        //TODO:handle data from ResultModel
        return axios.delete(url, data)
    }
}
